import React, { useState } from 'react';
import { carrierLogo } from '../../utils/carrierLogo';

/* ---- Carrier logo (self-contained brand chips; no external assets) ---- */
// To use real logo images instead, drop files in public/assets/images/carriers/
// and render an <img> here keyed on the same match.
const CARRIER_BRANDS = [
  { test: /fedex/i, node: (<><span style={{ color: '#4D148C' }}>Fed</span><span style={{ color: '#FF6600' }}>Ex</span></>), bg: '#ffffff', border: true },
  { test: /\bdhl\b/i, text: 'DHL', bg: '#FFCC00', fg: '#D40511', italic: true },
  { test: /\bups\b/i, text: 'UPS', bg: '#351C15', fg: '#FFB500' },
  { test: /aramex/i, text: 'aramex', bg: '#ffffff', fg: '#E4032E', border: true },
  { test: /dtdc/i, text: 'DTDC', bg: '#E11B22', fg: '#ffffff' },
  { test: /blue\s*dart/i, text: 'Blue Dart', bg: '#ffffff', fg: '#002F87', border: true },
  { test: /delhivery/i, text: 'Delhivery', bg: '#ffffff', fg: '#E4002B', border: true },
  { test: /\bdpd\b/i, text: 'DPD', bg: '#DC0032', fg: '#ffffff' },
  { test: /ddp/i, text: 'DDP', bg: '#F17221', fg: '#ffffff' },
  { test: /xfas|sendmyparcel|self|priority/i, text: 'Self', bg: '#F17221', fg: '#ffffff' },
];

const CarrierLogo = ({ carrier, size = 'md' }) => {
  const h = size === 'sm' ? 'h-4' : 'h-6';
  const [imgError, setImgError] = useState(false);
  if (!carrier) return null;
  const logo = carrierLogo(carrier);
  if (logo && !imgError) {
    return (
      <img
        src={logo}
        alt={carrier}
        title={carrier}
        onError={() => setImgError(true)}
        className={`${h} w-auto max-w-[60px] object-contain flex-shrink-0`}
      />
    );
  }
  const base = `inline-flex items-center justify-center ${h} ${size === 'sm' ? 'min-w-[34px] px-1.5 text-[10px]' : 'min-w-[46px] px-2 text-[11px] rounded'} font-extrabold leading-none tracking-tight whitespace-nowrap flex-shrink-0`;
  const brand = CARRIER_BRANDS.find((b) => b.test.test(carrier));
  if (brand) {
    return (
      <span
        className={`${base} ${brand.border ? 'border border-gray-200' : ''} ${brand.italic ? 'italic' : ''}`}
        style={{ backgroundColor: brand.bg, color: brand.fg }}
        title={carrier}
      >
        {brand.node || brand.text}
      </span>
    );
  }
  const initials =
    carrier.replace(/[^a-z ]/gi, '').trim().split(/\s+/).map((w) => w[0]).join('').slice(0, 3).toUpperCase() ||
    carrier.slice(0, 2).toUpperCase();
  return <span className={`${base} bg-gray-100 text-gray-600 border border-gray-200`} title={carrier}>{initials}</span>;
};

export default CarrierLogo;
